export type AddressDistanceProps = UiComponentProps & {
  /** The distance to the address */
  distance?: number
  /** Unit of measurement */
  unit?: 'km' | 'mi'
}

export function AddressDistance({ distance, unit = 'km', ...props }: AddressDistanceProps) {
  if (distance === undefined) return null

  return (
    <span {...props}>
      {distance} {unit}
    </span>
  )
}
